module.exports = __webpack_public_path__ + "static/media/imgAIModerator.8f6e2b89.png";